import GA_EVENTS from '../ga_constants';
import { setBehaviourEvent } from '../ga_interface';
import { Filters } from '../../../_flux/constants/filter/filters';
import formatCurrency from '../../currency/format_to_currency';

function showSectionContents(sectionName) {
    const category = GA_EVENTS.catalogFiltersDesktop.category;
    const action = GA_EVENTS.catalogFiltersDesktop.actions.openSection;

    setBehaviourEvent({ category, action, label: sectionName, beforeUnload: true });
}

function hideSectionContents(sectionName) {
    const category = GA_EVENTS.catalogFiltersDesktop.category;
    const action = GA_EVENTS.catalogFiltersDesktop.actions.closeSection;

    setBehaviourEvent({ category, action, label: sectionName, beforeUnload: true });
}

function resetSectionContents(sectionName) {
    const category = GA_EVENTS.catalogFiltersDesktop.category;
    const action = GA_EVENTS.catalogFiltersDesktop.actions.resetSectionFilters;

    setBehaviourEvent({ category, action, label: sectionName, beforeUnload: true });
}

function changeFilter(filterName, filterValue, currencyIsoCode, mainObj) {
    const category = GA_EVENTS.catalogFiltersDesktop.category;
    
    let label = filterValue || `All ${mainObj.label}`;
    if (filterName === Filters.PRICE_MIN || filterName === Filters.PRICE_MAX) {
        label = formatCurrency(filterValue, currencyIsoCode, true);
    }
    const action = GA_EVENTS.catalogFiltersDesktop.actions.setFilter[filterName];

    setBehaviourEvent({ category, action, label, beforeUnload: true });
}

function showToolTipAction(filterName) {
    const category = GA_EVENTS.catalogFiltersDesktop.category;
    const action = GA_EVENTS.catalogFiltersDesktop.actions.showToolTip;

    setBehaviourEvent({ category, action, label: filterName });
}

export {
    showSectionContents,
    hideSectionContents,
    resetSectionContents,
    changeFilter,
    showToolTipAction
};